// Country list for the Settings "Personal Information" location picker.
// Cities are curated per-country rather than a full global database — where
// we don't have a curated list, the UI falls back to a free-text city input.
export const COUNTRIES = [
  "Azerbaijan", "Turkey", "Georgia", "Russia", "Ukraine", "Kazakhstan", "Uzbekistan",
  "Turkmenistan", "Tajikistan", "Kyrgyzstan", "Iran", "Armenia", "Belarus", "Moldova",
  "United States", "Canada", "United Kingdom", "Germany", "France", "Italy", "Spain",
  "Portugal", "Netherlands", "Belgium", "Switzerland", "Austria", "Poland", "Czechia",
  "Slovakia", "Hungary", "Romania", "Bulgaria", "Greece", "Sweden", "Norway", "Denmark",
  "Finland", "Iceland", "Ireland", "Estonia", "Latvia", "Lithuania", "Croatia", "Serbia",
  "Slovenia", "Bosnia and Herzegovina", "North Macedonia", "Albania", "Cyprus", "Malta",
  "Luxembourg", "China", "Japan", "South Korea", "India", "Pakistan", "Bangladesh",
  "Sri Lanka", "Nepal", "Indonesia", "Malaysia", "Singapore", "Thailand", "Vietnam",
  "Philippines", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain",
  "Oman", "Israel", "Jordan", "Lebanon", "Iraq", "Egypt", "Morocco", "Algeria", "Tunisia",
  "South Africa", "Nigeria", "Kenya", "Ethiopia", "Ghana", "Brazil", "Argentina", "Chile",
  "Colombia", "Mexico", "Peru", "Venezuela", "Ecuador", "Uruguay", "Australia", "New Zealand",
  "Other",
];

export const CITIES_BY_COUNTRY = {
  "Azerbaijan": [
    "Baku", "Ganja", "Sumgayit", "Mingachevir", "Lankaran", "Shaki", "Yevlakh", "Nakhchivan",
    "Shirvan", "Khachmaz", "Guba", "Gabala", "Zaqatala", "Salyan", "Imishli", "Bilasuvar",
    "Neftchala", "Agjabadi", "Barda", "Goychay", "Ujar", "Sabirabad", "Shamakhi", "Gusar",
    "Astara", "Masalli", "Jalilabad", "Siyazan", "Khizi", "Absheron", "Khankendi",
  ],
  "Turkey": ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Adana", "Konya", "Gaziantep", "Trabzon", "Eskisehir"],
  "Georgia": ["Tbilisi", "Batumi", "Kutaisi", "Rustavi", "Zugdidi", "Gori", "Poti"],
  "Russia": ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan", "Nizhny Novgorod", "Rostov-on-Don"],
  "Ukraine": ["Kyiv", "Kharkiv", "Odesa", "Dnipro", "Lviv", "Zaporizhzhia"],
  "Kazakhstan": ["Almaty", "Astana", "Shymkent", "Karaganda"],
  "United States": ["New York", "Los Angeles", "Chicago", "Houston", "Boston", "San Francisco", "Seattle", "Washington, D.C."],
  "United Kingdom": ["London", "Manchester", "Birmingham", "Edinburgh", "Glasgow", "Liverpool"],
  "Germany": ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Stuttgart"],
  "France": ["Paris", "Marseille", "Lyon", "Toulouse", "Nice"],
  "Italy": ["Rome", "Milan", "Naples", "Turin", "Florence"],
  "Poland": ["Warsaw", "Krakow", "Lodz", "Wroclaw", "Gdansk"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah"],
  "China": ["Beijing", "Shanghai", "Guangzhou", "Shenzhen"],
  "India": ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai"],
};

export const getCitiesForCountry = (country) => CITIES_BY_COUNTRY[country] || [];
